import api from "../../../../../api";

export const requestGetAddresses = () => api.get("/address");

export const requestCreateAddress = (addressData) =>
    api.post("/address", addressData);
